import type React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-container">
      <p>© {currentYear} Yamaha Music School - Primary Course</p>
    </footer>
  );
};

export default Footer;
